// PRODUCTION — flow editor load error
import React from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

export interface FlowEditorErrorStateProps {
  message: string
}

export function FlowEditorErrorState({ message }: FlowEditorErrorStateProps) {
  return (
    <div css={tw`flex flex-col items-center justify-center gap-4 p-16`}>
      <Typography variant="h4" css={tw`text-critical-500`}>
        Error
      </Typography>
      <Typography variant="body2" css={tw`text-shades-600`}>
        {message}
      </Typography>
    </div>
  )
}
